import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"

import { DeleteAddonOverlayProps } from "../DeleteAddonOverlay"
import { DeleteAddonOverlayViewModel } from "../DeleteAddonOverlayView"

export function useDeleteAddonOverlayViewModel({
  payload
}: DeleteAddonOverlayProps): DeleteAddonOverlayViewModel {
  const { onDelete, addonName } = payload
  const { closeOverlay } = useCurrentOverlay()

  const handleDelete = useEvent(() => {
    onDelete()
    closeOverlay()
  })

  return {
    addonName,
    closeOverlay,
    deleteAddon: handleDelete
  }
}
